import React, { useState } from "react";
import "./features.css";
import vixr1 from '../../assests/images/vixr1.jpg';
import vixr2 from '../../assests/images/vixr2.jpg';
import barriers from '../../assests/images/barriers.jpg';
import artoreal4 from '../../assests/images/artoreal4.jpg';

const Features = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqData = [
    {
      id: 1,
      title: "VIXR",
      description:
        "Artoreal is powered by ViXR, a proprietary technology that harnesses the power of AI, AR & VR and Emotional Analytics to help one find the desired framed artwork for your home.ViXR enables one to experience art like never before,. Select an image from Artoreals vast collections or Upload a photo of your wall and visualize how the artwork will look in your home with our AR technology. ViXR helps you automatically select the best size to print, depending on the quality of the photo.With Virtual Art Galleries, artists Exhibit their art to a world-wide audience of art lovers and buyers who can take a walk-through in Virtual Reality.",
      images: [vixr1,vixr2], 
    },
    {
      id: 2,
      title: "Barriers Disconnecting Makers of Art from Buyers of Art",
      description:
        "Following barriers create the distance between buyers and sellers of art:",
      images: [barriers], 
    },
    {
      id: 3,
      title: "Artoreal Breaks Barriers",
      description:
        "This is how Artoreal creates a seamless digital commerce experience for Art: ",
      images: [artoreal4],
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <div className="faq-content">
        <h2>Re-imagining the Art Ecosystem</h2>
        <p>
        The fundamental premise of Artoreal is to bridge artists, buyers, galleries & printing-framing-delivery service providers.
         And to do so while delivering a superior hassle-free experience digitally.   
         <br/>
         <br/>
         Artoreal does this by  offering a wide
          online selection of art, wide range of customisation options, affordable pricing, and deploying ViXR technology that 
          makes selecting a simple and intelligent, and buying a one-shop, experience without hassles. 
        </p>
      </div>

      <div className="faq-list">
        {faqData.map((item, index) => (
          <div key={item.id} className="faq-item">
            <div className="faq-title" onClick={() => toggleFAQ(index)}>
              <span>{String(index + 1).padStart(2, "0")}</span> {item.title}
              <span className="faq-toggle">{openIndex === index ? "−" : "+"}</span>
            </div>

            {openIndex === index && (
              <div className="faq-content-box">
                <p className="faq-description">{item.description}</p>

                <div className={`faq-images ${item.images.length === 2 ? "double" : ""}`}>
                  {item.images.map((src, imgIndex) => (
                    <img key={imgIndex} src={src} alt={`Feature ${index + 1}`} className="faq-image" />
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Features;
